module.exports = require(11).EventEmitter;
